"use strict";

import Modal from 'bootstrap/js/dist/modal';
import {onFind} from "../libs/@elements/init-modules-in-scope";
import {on} from "../libs/@elements/dom-utils";

export function init () {

    if (!sessionStorage.getItem(_config.swissModalSessionKey)) {
        setTimeout(function(){
            let swissModal = new Modal(document.getElementById('swissModal'), {
                backdrop: 'static'
            });
            swissModal.show();
        }, 250);
    }

    onFind('.js-swiss-modal__dismiss', function (link) {
        on('click', function () {
            sessionStorage.setItem(_config.swissModalSessionKey, 'accepted');
        }, link);
    });
}